import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Test from '@/views/Test'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }
]

// 测试环境 可以显示test页面
if (process.env.VUE_APP_MODE === 'test') {
  routes.push({
    path: '/test',
    name: 'Test',
    component: Test
  })
}

// 不存在页面  跳回首页
routes.push({
  path: '*',
  redirect: '/'
})

const router = new VueRouter({
  routes
})

export default router
